module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "hear-from-you.a536f6c9.jpeg" + "?" + Date.now();